<template>
  <p
    v-show="statusMessage"
    class="mt-2 pl-0.5 text-xs text-left"
    :class="{ 'text-green-600': isSuccess, 'text-red-600': isError }"
  >
    {{ statusMessage }}
  </p>
</template>

<script>
export default {
  props: {
    statusMessage: { type: String, default: null },
    isSuccess: { type: Boolean, default: false },
    isError: { type: Boolean, default: false },
  },
}
</script>
